module.exports = __webpack_public_path__ + "static/media/wheelchair_heavy.93fefab7.svg";